module.exports = __webpack_public_path__ + "static/video1-ab373928d49e56568f5b9eb90720c2b6.png";